import { useReportingToolsStore } from '@/pages/reporting-tools/store/useReportingToolsStore';
import { useSuspenseQuery } from '@apollo/client';
import {
  FETCH_REPORTING_TOOLS_COHORT_SUMMARY,
  FetchReportingToolsCohortSummaryQuery,
  FetchReportingToolsCohortSummaryQueryVariables,
} from '@edwin-group/cj-graphql';
import { useDeferredValue } from 'react';

export const useCohortSummary = () => {
  const filtersStore = useReportingToolsStore((state) => state.filters);
  const filters = useDeferredValue(filtersStore);
  const isPending = filtersStore !== filters;

  const { data, error } = useSuspenseQuery<
    FetchReportingToolsCohortSummaryQuery,
    FetchReportingToolsCohortSummaryQueryVariables
  >(FETCH_REPORTING_TOOLS_COHORT_SUMMARY, {
    fetchPolicy: 'cache-and-network',
    variables: {
      schoolDocumentIds: filters.schoolDocumentIds,
      academicYear: filters.academicYear,
      cohortDocumentIds: filters.cohortDocumentIds,
    },
    errorPolicy: 'all',
  });

  return {
    data: data?.fetchReportingToolsCohortSummary?.cohortSummary || [],
    error,
    isPending,
  };
};
